import { Box } from "@mui/material";
import {
  createFileRoute,
  Outlet,
  redirect,
  useNavigate,
  useParams,
} from "@tanstack/react-router";
import { useEffect } from "react";

import {
  hasElevatedAccessValue,
  useHasElevatedAccess,
  usePrivilegedModeStore,
} from "@/utils/privilegedMode";

export const Route = createFileRoute("/_auth/settings/$siteId/_zeroAdmin")({
  beforeLoad: ({ context }) => {
    const disabled = usePrivilegedModeStore.getState().disabled;
    if (!hasElevatedAccessValue(context.auth?.user?.user.role, disabled)) {
      throw redirect({ to: ".." });
    }
  },
  component: ZeroAdminLayout,
});

function ZeroAdminLayout() {
  const navigate = useNavigate();
  const { siteId } = useParams({ strict: false });
  const hasElevatedAccess = useHasElevatedAccess();

  // beforeLoad only runs on navigation; toggling privileged mode off while
  // already on a zero-admin page must boot the user out reactively. Navigate to
  // the concrete settings parent — a relative ".." resolves from this pathless
  // layout's (segment-less) match and would no-op.
  useEffect(() => {
    if (!hasElevatedAccess) {
      void navigate({
        to: "/settings/$siteId",
        params: { siteId: siteId ?? "" },
      });
    }
  }, [hasElevatedAccess, navigate, siteId]);

  if (!hasElevatedAccess) return null;

  return (
    <Box
      sx={{ minWidth: 0, display: "flex", flexDirection: "column", flex: 1 }}
    >
      <Outlet />
    </Box>
  );
}
